/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_Missing_SexInputs */

const en_us2_exercise_personal_strength_missing_sex = /** @type {(inputs: Exercise_Personal_Strength_Missing_SexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sex (the norms are split by it)`)
};

const pt_br2_exercise_personal_strength_missing_sex = /** @type {(inputs: Exercise_Personal_Strength_Missing_SexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sexo (as referências são separadas por ele)`)
};

const es_419_exercise_personal_strength_missing_sex = /** @type {(inputs: Exercise_Personal_Strength_Missing_SexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sexo (las referencias se separan por él)`)
};

const pt_pt2_exercise_personal_strength_missing_sex = /** @type {(inputs: Exercise_Personal_Strength_Missing_SexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sexo (as referências estão separadas por sexo)`)
};

const fr_fr2_exercise_personal_strength_missing_sex = /** @type {(inputs: Exercise_Personal_Strength_Missing_SexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sexe (les normes en dépendent)`)
};

const de_de2_exercise_personal_strength_missing_sex = /** @type {(inputs: Exercise_Personal_Strength_Missing_SexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschlecht (die Normwerte sind danach getrennt)`)
};

const it_it2_exercise_personal_strength_missing_sex = /** @type {(inputs: Exercise_Personal_Strength_Missing_SexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sesso (i riferimenti sono divisi in base a questo)`)
};

/**
* | output |
* | --- |
* | "sex (the norms are split by it)" |
*
* @param {Exercise_Personal_Strength_Missing_SexInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_missing_sex = /** @type {((inputs?: Exercise_Personal_Strength_Missing_SexInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_Missing_SexInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_missing_sex(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_missing_sex(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_missing_sex(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_missing_sex(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_missing_sex(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_missing_sex(inputs)
	return en_us2_exercise_personal_strength_missing_sex(inputs)
});
export { exercise_personal_strength_missing_sex as "exercise-personal.strength_missing_sex" }